import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useApiClient } from '../../context/ApiClientContext';
import DxHxForm, { dxHxDefaultValues } from './DxHxForm';
import { useForm } from '../../components/useForm';
import ButtonWithModal from '../../components/ButtonWithModal';

export default function DxHxAdditionButton(props) {
  const { reloadCallback } = props;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const apiClient = useApiClient();

  const {
    values,
    setValues,
    handleInputChange,
  } = useForm(dxHxDefaultValues);

  const onSubmit = () => apiClient.addDxHx(values);

  const onSuccess = () => {
    if (reloadCallback) {
      reloadCallback();
    }
    setModalIsOpen(false);
  };

  return (
    <ButtonWithModal
      buttonText="Create DxHx"
      modalTitle="Create DxHx"
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      onClose={() => setValues(dxHxDefaultValues)}
    >
      <DxHxForm
        values={values}
        handleInputChange={handleInputChange}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        successMsg="DxHx created!"
        errorMsg="Error creating DxHx"
      />
    </ButtonWithModal>
  );
}

DxHxAdditionButton.propTypes = {
  reloadCallback: PropTypes.func,
};

DxHxAdditionButton.defaultProps = {
  reloadCallback: null,
};
